import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoggedIn: !!localStorage.getItem('geodir_Token'),
  },
  getters:{
    isLoggedIn: state => () => state.isLoggedIn,
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
